// extracted by mini-css-extract-plugin
export default {"cell":"animal-list_cell__dThbm","custModel":"animal-list_custModel__pEOeb"};